import { render, staticRenderFns } from "./ResearchersList.vue?vue&type=template&id=2a57c9e5&scoped=true&"
import script from "./ResearchersList.vue?vue&type=script&lang=js&"
export * from "./ResearchersList.vue?vue&type=script&lang=js&"
import style0 from "./ResearchersList.vue?vue&type=style&index=0&id=2a57c9e5&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a57c9e5",
  null
  
)

export default component.exports